export default __webpack_public_path__ + "static/media/icon-cart.6fbcc20d.svg";